import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TypingPageRoutingModule } from './typing-routing.module';
import { SharedModule } from '../keyboard/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TypingPage } from './typing.page';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HandComponent } from './hand.component';
import { SafePipe } from '../shared/pipes/safe.pipe';
import { HandOverlayComponent } from './hand-overlay.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TypingPageRoutingModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [TypingPage, HandComponent, SafePipe, HandOverlayComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TypingPageModule {}